// extracted by mini-css-extract-plugin
module.exports = {"responsiveImage":"ResponsiveImage_responsiveImage__i_D6F","loading":"ResponsiveImage_loading__eKzjK"};